export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Қарсы тарап туралы ақпарат"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Шот / E-mail / Телефон"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Крипто-адрес / E-mail / Телефон"])}
}